export const customSettings = {
	pagescroll: {
		threshold: 100
	},
	ndssearch: {
		pageheaderHeight: '48px'
	}
};

// Links im Menü klickbar machen wenn wir mobil sind
var menuLevel1Links = document.getElementsByClassName('menu__link-level--1');
for (var i = 0; i < menuLevel1Links.length; i++) {
  menuLevel1Links[i].addEventListener('click', (event) => {
    if(window.innerWidth < 768) {
      event.currentTarget.parentElement.getElementsByTagName('button')[0].click();
    }
  }, false);
}
